<template>
  <div>
  </div>
</template>

<script>

export default {
  async created() {
    // 有登入使用者：發起登出（signoutRedirect 會先清除使用者，登出後導回此頁）
    // 沒有使用者：登出完成被導回，回首頁後由路由守衛導至登入頁
    this.$store.dispatch('initialOidc');
    const user = await this.$store.dispatch('getUserInfo');
    if (user) {
      this.$store.dispatch('logoutRedirectUnityPage');
      return;
    }
    this.$router.replace('/');
  },
};
</script>
